<template>
    <main class="ForgotPassword">
        <v-card class="ForgotPassword_card">
            <div class="ForgotPassword_box">
                <div class="d-flex justify-end mb-3">
                    <img src="@/assets/img/logo-login1.svg" alt="logo">
                </div>
                <form class="ForgotPassword_form">
                    <div class="text-h4 mb-3">Welcome</div>
                    <div class="text mb-8"><p>Please create a new password</p></div>
                    
                    <div class="ForgotPassword_field">
                        <label class="hidden">New Password</label>
                        <input type="password" placeholder="New Password" v-model="newpassword">
                    </div>
                    <div class="ForgotPassword_field">
                        <label class="hidden">Confirm New Password</label>
                        <input type="password" placeholder="Confirm New Password" v-model="renewpassword">
                    </div>
                    <div class="ForgotPassword_submit">
                        <v-btn color="primary" :disabled="verificationPass()" @click="activeAccount">Set Password</v-btn>
                    </div>
                </form>
            </div>
        </v-card>
    </main>
</template>

<script>
import { RouterLink } from 'vue-router';
import {  mapActions } from "vuex";

    export default {
        name: "ForgotPassword",
        data() {
            return {
                newpassword: null,
                renewpassword: null,
                email : null,
                token : null,
                showError : false,
                score : 0
            };
        },
        components: {
            RouterLink
         },
        beforeMount(){
            const explodePath = this.$route.params.pathMatch.split('/');
            this.email = explodePath[0];
            this.token = explodePath[1];
        },
        methods:{
            ...mapActions(["activeAccountFn"]),
            showScore (score) {
                this.score = score;
            },
            verificationPass(){
                if(this.newpassword === this.renewpassword)
                    return false
                else
                    return true;
            },
            async activeAccount(){
                const user = new FormData();
                user.append('email',this.email);
                user.append('token',this.token);
                user.append('newpassword',this.newpassword);
                user.append('operation','activeAccount');
                try {
                    const response  = await this.activeAccountFn(user),
                        data      = response.data;

                    if(data.result == 'error'){
                        console.log(data.errorProcessRecovery);
                        this.showError = true
                    }else{
                        this.showError = false
                    }
                    
                } catch (error) {
                    console.error(error)
                    this.showError = true
                }
            }
        }
        
    }
</script>

<style lang="scss" scoped>
    @import "~@/scss/colors.scss";
    .ForgotPassword{
        background: $purple;
        display: grid;
        place-items: center;
        width: 100%;
        height: auto;
        min-height: 100vh;
        padding: 20px;
        &_card{
            width: 100%;
            max-width: 900px;
            padding: 70px 30px;
        }
        &_box{
            display: block;
            width: 100%;
            max-width: 700px;
            margin: auto;
        }
        .text{
            color: #767676;
            font-size: 19px;
        }
        &_field{
            display: block;
            margin-bottom: 20px;
            position: relative;
            label{
                width: 0;
                height: 0;
                visibility: hidden;
                position: absolute;
                opacity: 0;
            }
            input{
                display: block;
                width: 100%;
                max-width: 350px;
                height: 35px;
                padding: 0 20px;
                border: 1px solid #BFBFBF;
                border-radius: 4px;
                &::placeholder{
                    color: #BFBFBF;
                }
            }
        }
        .small{
            color: #767676;
            font-size: 13px;
        }
        &_submit{
            display: block;
            margin-top: 30px;
            .v-btn{
                min-width: 180px;
            }
        }
    }

    #app .ForgotPassword .text-h4{
        font: 300 34px 'Spectral', serif !important;
        color: $purple;
        letter-spacing: -0.03em !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/PasswordReset.vue